import { render, staticRenderFns } from "./MobileMenuItemWithSubmenus.vue?vue&type=template&id=23c3ad23&scoped=true&"
import script from "./MobileMenuItemWithSubmenus.vue?vue&type=script&lang=js&"
export * from "./MobileMenuItemWithSubmenus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c3ad23",
  null
  
)

export default component.exports